import React from "react";
import { motion } from "framer-motion";
import {
  ShieldCheck,
  UserCheck,
  CreditCard,
  AlertCircle,
  FileText,
  Star,
  Camera,
  RefreshCw,
  Lock, // added icon for privacy
} from "lucide-react";
import "./RegistrationPolicies.css";

const RegistrationPolicies = () => {
  const policies = [
    {
      icon: <UserCheck className="policy-icon1123 blue1123" />,
      title: "1. Eligibility",
      description:
        "Participants must meet the age, skill, and category criteria as defined by the specific competition rules. Proof of identity or eligibility may be requested at any time.",
    },
    {
      icon: <FileText className="policy-icon1123 green1123" />,
      title: "2. Registration Process",
      description:
        "All registrations must be completed through the official Aattum TPL website or authorized platforms. Accurate and complete information is required. Registration is confirmed only after payment and confirmation email.",
    },
    {
      icon: <AlertCircle className="policy-icon1123 orange1123" />,
      title: "3. Deadlines",
      description:
        "Participants must register by the posted deadlines. Late entries are not accepted unless approved by the TPL committee.",
    },
    {
      icon: <CreditCard className="policy-icon1123 purple1123" />,
      title: "4. Payment Terms",
      description:
        "Fees must be paid in full at registration. Accepted methods include credit/debit card or bank transfer as listed.",
    },
    {
      icon: <ShieldCheck className="policy-icon1123 red1123" />,
      title: "5. No Refund Policy",
      description:
        "All registration and league fees are non-refundable. No refunds will be issued for scheduling conflicts, personal emergencies, injury, illness, or event cancellation due to force majeure. Transfers of registration are not permitted unless officially approved.",
    },
    {
      icon: <Star className="policy-icon1123 yellow1123" />,
      title: "6. Code of Conduct",
      description:
        "All participants must follow Aattum TPL’s code of conduct. Disrespect or violations may result in disqualification without refund.",
    },
    {
      icon: <Camera className="policy-icon1123 indigo1123" />,
      title: "7. Media Release",
      description:
        "By registering, you grant Aattum TPL the right to use your image and media for promotional purposes.",
    },
    {
      icon: <RefreshCw className="policy-icon1123 teal1123" />,
      title: "8. Policy Updates",
      description:
        "TPL may update these policies at any time. Significant changes will be communicated to registered participants.",
    },
    {
      icon: <Lock className="policy-icon1123 gray1123" />,
      title: "9. Data Privacy & Security",
      description:
        "Aattum TPL is committed to protecting your personal information. All data collected during registration will be securely stored and used only for official Talented Premier League operations in compliance with applicable data protection laws.",
    },
  ];

  return (
    <div className="policy-page1123">
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="policy-header1123"
      >
        <h1>AattumTalented Premier League</h1>
        <p>Registration Policies</p>
        <div className="header-line1123"></div>
      </motion.div>

      <div className="policy-grid1123">
        {policies.map((policy, index) => (
          <motion.div
            key={index}
            className="policy-card1123"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <div className="policy-title1123">
              {policy.icon}
              <h2>{policy.title}</h2>
            </div>
            <p>{policy.description}</p>
          </motion.div>
        ))}
      </div>

     
    </div>
  );
};

export default RegistrationPolicies;
